<template>
  <div class="page-container" ref="container">
    <div class="page-box box-cls-1">
      <div class="page-content">
        <Header />
        <div class="main">

          <img class="center-box  pc-banner" src="../assets/major/banner.png" alt
               style="width:auto;height:600px;margin: auto;" />
          <img class="center-box phone-banner" src="../assets/major/banner.png" alt
               style="width:98%;margin: auto;" />
          <div class="left-box">
            <div>
              <div class="download-buttons">
                <el-popover placement="bottom" disabled popper-class="download-popover">
                  <div class="down-item">
                    <div class="down-hide">
                      <img class="hide-img ios-img" src="../assets/major/ios_qr.png" alt="">
                      <div style="margin-top:10px;font-weight: bold">请用苹果手机扫码下载</div>
                    </div>
                  </div>
                  <div class="download-btn" slot="reference"  @click="download(4)">
                    <img class="default-cls" src="../assets/major/down-btn-ios.png" alt="iOS">
                    <img class="show-cls" src="../assets/major/down-btn-ios-show.png" alt="iOS">
                  </div>
                </el-popover>
                <el-popover
                v-for="(url, idx) in andDownUrls"
                :key="`${url}-${idx}`"
                  placement="bottom"
                  disabled
                  popper-class="download-popover"
                >
                  <div class="download-btn" slot="reference" @click="download(3, url)">
                    <img
                      class="default-cls"
                      src="../assets/major/down-btn-android.png"
                      alt="Android"
                    />
                    <img
                      class="show-cls"
                      src="../assets/major/down-btn-android-show.png"
                      alt="Android"
                    />
                  </div>
                </el-popover>
              </div>
            </div>
          </div>

          <div class="left-box phone-text">
          </div>
          <div v-if="isIOS" class="phone-btn">
            <div class="btn-cls" @click="goDown">下载</div>
          </div>
          <div class="download-container" v-if="isAndroid">
            <div v-for="(url, i) in andDownUrls" :key="url" class="phone-btn">
              <div class="btn-cls" @click="goDown(url)">下载 {{ i + 1 }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />

  </div>
</template>

<script>

import { getAndDownUrl } from '../api/apply'
import Header from '@/components/header'
import Footer from '@/components/footer'

export default {
  name: 'marjor',
  components: { Header, Footer },
  data () {
    return {
      ctx: null,
      animationObj: [],
      canvasW: null,
      canvasH: null,
      isCom: 1,
      isLogin: false,
      logoUrl: require('@/assets/major/logo_qr.png'),
      andDownUrls: [],
      iosDownUrl: null,
      activeDownload: null,
      isIOS: false,
      isAndroid: false
    }
  },

  mounted () {
    this.getAndDown()
    this.isCom = 4
    document.title = '发发'
    let clientWidth = document.body.clientWidth || document.documentElement.clientWidth
    if (clientWidth < 500) {
      this.wdithNum = `90%`
    }

    // 检测用户的操作系统
    const userAgent = navigator.userAgent.toLowerCase()
    this.isAndroid = userAgent.includes('android')
    this.isIOS = /iphone|ipad|ipod/.test(userAgent)

    // 获取是否登录缓存
    let userInfo = localStorage.getItem('login_user')
    this.isLogin = !!userInfo
  },
  methods: {
    download (type, urlStr) {
      let url = ''
      // type 1 mac 2 windows 3 and
      switch (type) {
        case 3:
          url = urlStr
          break
        case 4:
          url = this.iosDownUrl
          break
      }
      window.open(url)
    },
    getAndDown () {
      getAndDownUrl().then(res => {
        if (res.code == 200) {
          this.andDownUrls = res.data.url.android
          this.iosDownUrl = res.data.url.ios[0]
        }
      })
    },

    /** 跳转到用户 */
    goBuy () {
      this.$router.push({ path: '/user/meal' })
    },
    /** 下载地址 */
    goDown (url) {
      if (this.isIOS) {
        window.location.href = this.iosDownUrl
      } else if (this.isAndroid) {
        window.location.href = url
      } else {
        alert('不支持')
      }
    }
  },
  destroyed () {
    window.onresize = null
  }
}
</script>

<style lang="scss">
@import "@/assets/css/style";
.page-container{
  min-height:100vh;
}
.down-item {
  .down-hide{
    display: flex;
    flex-direction:  column;
    align-items: center;
    justify-content: center;
    .hide-img {
      height: 150px;
      width: 150px;
      padding-top: 6px;
    }

    .ios-img{
      height: 200px;
      width: 200px;
    }
  }
}
.text-btn-cls {
  font-size: 14px;
  color: $--color-primary;
  cursor: pointer;
  margin-bottom: 12px;
  display: inline-block;
}

.text-btn-item {
  margin-top: -5px;
  margin-bottom: 10px !important;

  .text-btn-box {
    text-align: left;
    position: relative;
    height: 24px;
    line-height: 24px;
  }

  .text-btn-cls {
    display: inline-block;
    margin-bottom: 0;
    position: absolute;
    right: 0;
    top: 0;
  }

  .text-btn-cls:first-child {
    right: unset;
    left: 0;
  }

  .text-right {
    left: unset !important;
    right: 0 !important;
  }
}

.pwd-box {
  position: relative;

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 6px;

    img {
      height: 20px;
      width: 20px;
      cursor: pointer;
    }
  }
}

@media screen and (min-width: 1000px) {
  .pc-banner{
    display: block;
  }
  .phone-banner{
    display: none;
  }
  .page-container {
    &:after {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      //background: url("../assets/major/body-bg.png") no-repeat;
      background-size: 100% 100%;
      background-position-y: 1060px;
      z-index: -1;
      background: #aeede1;
    }
    &:before {
      content: '';
      position: absolute;
      top:0;
      left:0;
      width: 100%;
      height: 100%;
      //background: url("../assets/major/bg_1.png") no-repeat;
      background-size: cover;
      background-position:center center;
      z-index: -1;
      background: #aeede1;
    }
    width: 100%;
    font-size: 16px;
    position: relative;

    .phone-btn {
      display: none;
    }

    .page-content {
      width: 1200px;
      margin: 0 auto;

      .btn-cls {
        width: 180px;
        height: 56px;
        background: #fff;
        border-radius: 12px;
        color: #000;
        font-size: 20px;
        display: inline-block;

        cursor: pointer;
        font-weight: 600;
        text-align: center;
      }

      .btn-cls:hover {
        color: #fff;
        background: $--color-primary;
      }

      .main {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        box-sizing: border-box;
        padding-top: 100px;

        .left-box {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          color: #040027;
          h1 {
            margin-bottom:20px;
            font-size: 40px;
            img{
              height:108px;
            }
          }

          h3 {
            font-size: 32px;
            margin-bottom: 20px;
          }

          .text-cls {
            margin-top: 30px;
            line-height: 38px;
            font-size: 24px;
          }

          .btn-cls {
            border-radius: 12px;
            line-height: 56px;
            margin-top: 27px;
          }

          .mar-right {
            margin-right: 16px;
          }
        }

        .phone-text {
          display: none;
        }

      }
    }
    .box-cls-1 {
      background-size: 100% 100%;
    }

    .box-cls-3, .box-cls-4 {
      color: #fff;
      background-size: 100% 100%;

      .item-title-cls {
        font-size: 20px;
        font-weight: 600;
      }

      p {
        line-height: 24px;
        white-space: nowrap;
        color: rgba(0, 0, 0, 0.5);
        font-size: 14px;
      }

      .flex-img-cls {
        margin-top: 20px;
        width:auto;
        height:441px;
      }
    }

    .box-cls-5, .box-cls-3, .box-cls-4 {
      text-align: center;
      padding: 90px 0;
      height: auto !important;

      h1 {
        font-size: 40px;
        margin-bottom: 50px;
      }
      .item-title-cls {
        padding:0 0 8px;
        font-size: 20px;
        color:rgba(4, 0, 39, 1);
      }
    }

    .box-cls-2 {
      position: relative;
      top: -10px;

      .flex-box {
        display: flex;

        .flex-1 {
          flex-basis: 25%;
          position: relative;

          &:after {
            content: '';
            position: absolute;
            top: 16px;
            left: 20px;
            border-radius: 15px;
            width: 280px;
            height: 203px;
            background: rgba(0, 0, 0, 0);
            transition: all 0.3s ease;
          }

          &:hover {
            cursor: pointer;

            &:after {
              background: rgba(0, 0, 0, 0.5);
            }

          }

          .flex-img-cls {
            width: calc(100% + 20px);
          }
        }
      }
    }

    .box-cls-3 {
      // background: url("../assets/major/bg_3.png") no-repeat;
      background-size: 100% 100%;
      color: #040027;
      margin-top:60px;
      .flex-box{
        display: flex;
        gap: 60px;

      }
      .flex-1 {
        width: fit-content!important;
      }
    }

    .box-cls-4 {
      // background: url("../assets/major/bg_4.png") no-repeat;
      background-size: 100% 100%;
      color: #000;

      .tag-cls {
        color: #999;
      }

      .flex-1 {
        width: 24% !important;
      }
    }

    .box-cls-5 {
      // background: linear-gradient(180deg, #EAF3FF, #B1D9FE);

      .video-box {
        position: relative;

        .video-cls {
          width: 1280px;
          height: 720px;
          border-radius: 24px;
        }
      }
    }

    .flex-box {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;

      .flex-1 {
        width: 33%;
      }
    }

  }

  .meal-cls {
    border-radius: 40px !important;

    .el-dialog__body, .el-dialog__header {
      padding: 0;
    }

    .el-dialog__body {
      font-size: 0;
      overflow: hidden;
    }

    img {
      width: 100%;
    }
  }

  .upload-wrap {
    margin-top: 5px;

    .upload {
      position: relative;
      width: 150px;

      input {
        position: absolute;
        left: 0;
        top: 0;
        overflow: hidden;
        width: 80px;
        height: 36px;
        opacity: 0;
        cursor: pointer;
      }

      .el-button {
        position: absolute;
        left: 0;
      }
    }

    img {
      max-width: 200px;
    }
  }

  .fiexd-box {
    display: none;
  }

  .login-btn-cls {
    width: 60%;
  }

  .qrcode-box {
    display: flex;
    align-items: center;
    padding-top: 20px;
    justify-content: center;

    .qrcode-item {
      flex: 1;
      text-align: center;
      font-weight: 600;
      color: #000;
      margin: 0 20px;
    }

    .qrcode-title {
      margin: 8px 0;
    }

    .qrcode-img {
      height: 80px;
      width: 80px;
    }

    .btn-cls {
      width: 60px;
      height: 28px;
      line-height: 28px;
      border-radius: 4px;
      background: $--color-primary;
      color: #fff;
      font-weight: normal;
      display: inline-block;
      cursor: pointer;
    }

    .btn-cls:hover {
      opacity: 0.8;
    }
  }
}

@media screen and (max-width: 999px) {
  .pc-banner {
    display: none;
  }

  .phone-banner {
    display: block;
    width: 90%!important;
    margin-bottom: px2rem(150)!important;
  }
  .flex-box {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;

    .flex-1 {
      width: 46%;
    }
  }

  .page-container {
    //padding-bottom: px2rem(120);
  }

  .page-box {
    font-size: px2rem(32);
    text-align: center;
    color: #fff;
    width: 100%;

    h1 {
      font-size: px2rem(40);
      line-height: 1.6;
    }

    .main {
      padding: px2rem(100) 0;
    }

    .left-box {
      padding: px2rem(60) 0;
      color: #040027;
      display: none;

      h1 {
        font-size: px2rem(60);
      }

      h2 {
        font-size: px2rem(48);
      }

      .btn-cls {
        display: none;
      }
    }

    .phone-text {
      padding-top: px2rem(40);
      display: block;
      h1{
        font-size: px2rem(64);
        img{
          width: 80%;
          max-width: 350px;
        }
      }

      h3 {
        font-size: px2rem(40);
      }
    }

    .phone-btn {
      display: flex;
      align-items: center;
      justify-content: center;

      .btn-cls {
        width: px2rem(567);
        height: px2rem(84);
        line-height: px2rem(84);
        background: rgba(0, 186, 149, 1);
        border-radius: px2rem(12);
        color: #fff;
        text-align: center;
        font-size: px2rem(27);
        font-weight: 600;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .btn-cls.mar-right {
        color: #fff;
        background: $--color-primary;
        margin-right: px2rem(30);
      }
    }

    .text-cls {
      margin-top: px2rem(30);
      font-size: px2rem(30);
      line-height: 1.8;
    }

    .center-box {
      width: 90%;
      max-width: 450px;
      position:relative;
      top:40px;
    }

    .flex-box {
      color: #000;
    }

    .flex-img-cls {
      width: px2rem(320);
      margin-bottom: px2rem(20);
    }

    .item-title-cls {
      padding: px2rem(30) 0;
    }
  }

  .box-cls-1 {
    min-height: 100vh;
    background: #aeede1;
  }

  .box-cls-2, .box-cls-3, .box-cls-4 {
    display: none;

    h1 {
      color: #000;
      padding: px2rem(60) 0;
    }

    .tag-cls {
      display: none;
    }
  }
  .box-cls-3 {
    color: #fff;

    .tag-cls {
      color: #fff;
    }

    .flex-box {
      align-items: flex-start;
    }

    h1 {
      color: #fff;
      padding: px2rem(50) 0;
    }

    .item-title-cls {
      color: #fff;
    }

    h4 {
      padding-bottom: px2rem(50);
    }

    .bottom-btn {
      position: fixed;
      width: 100%;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 9;
      background: $--color-primary;
      height: px2rem(100);
      line-height: px2rem(100);
      text-align: center;
      padding-bottom: px2rem(40);
    }

    .btn-cls {
      background: #fff;
      color: $--color-primary;
      font-weight: bold;
      border-radius: px2rem(60);
      width: 90%;
      margin: px2rem(20) 0;
      display: inline-block;
    }

  }

  .box-cls-4 {
    color: #000;

    .tag-cls {
      color: #999;
    }
  }

  .box-cls-5 {
    display: none;
  }

  .upload-wrap {
    margin-top: px2rem(10);

    .upload {
      position: relative;
      width: px2rem(300);

      input {
        position: absolute;
        left: 0;
        top: 0;
        overflow: hidden;
        width: px2rem(80);
        height: px2rem(72);
        opacity: 0;
        cursor: pointer;
      }

      .el-button {
        position: absolute;
        left: 0;
      }
    }

    img {
      max-width: px2rem(120);
    }
  }

  .fiexd-box {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(90deg, #91EDF7 0%, #1C58CC 100%);
    text-align: center;
    font-weight: bold;

    .btn-cls {
      letter-spacing: px2rem(6);
      margin: px2rem(20) px2rem(30);
      height: px2rem(80);
      line-height: px2rem(80);
      border-radius: px2rem(40);
      background: #fff;
      font-size: px2rem(36);
    }
  }
}

.link-cs {
  position: fixed;
  left: calc(1200px + (100vw - 1200px) / 2);
  top: 471px;
  z-index: 100;
  width: 144px;
  height: 55px;
  border-radius: 9.6px;
  border-width: 1.2px;
  background-color: rgba(255, 255, 255, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 15px;
  font-weight: bold;
  transform: translateX(50%);
  color: #000;
  border: 1.2px solid rgba(219, 219, 221, 1);

  &:hover {
    background: #ddd;
  }

  img {
    width: 32px;
    height: 32px;
    margin-right: 10px;
  }
}

/* 针对小屏幕宽度调整 */
@media (max-width: 1800px) {
  .link-cs {
    right: 0;
    left: calc(100% - 202px) !important;
    transform: translateX(0)
  }
}

/* 针对小屏幕宽度调整 */
@media (max-width: 999px) {
  .link-cs {
    top: 2.7rem;
    border-radius: px2rem(24);
    // transform: translateX(10%) scale(0.6)!important;
    width: 2.66667rem;
    height: 0.85333rem;
    right: 0.37333rem !important;
    left: auto !important;
    font-size: px2rem(26);

    img {
      width: px2rem(49);
      height: px2rem(49);
      margin-right: px2rem(11)
    }
  }
  .chat-cls{
    display: none;
  }
}
.download-buttons {
  display: flex;
  gap: 10px;
  margin: 80px 0 50px;

  .download-btn {
    cursor: pointer;
    transition: all 0.3s ease;
    margin: 0 10px;

    .show-cls{
      display: none;
    }

    &:hover {
      transform: translateY(-2px);
      .default-cls {
        display: none;
      }
      .show-cls {
        display: block;
      }
    }

    img {
      width: 180px;
      height: 60px;
      height: auto;
    }
  }

  .down-item {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    padding: 20px;

    &:before {
      content: '';
      position: absolute;
      top: -8px;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-bottom: 8px solid #fff;
    }

    .down-img {
      width: 200px;
      height: auto;
    }

    .down-hide {
      text-align: center;

      .hide-img {
        width: 160px;
        height: 160px;
        margin-bottom: 10px;
      }

      div {
        color: #666;
        font-size: 14px;
      }
    }
  }
}

.left-box {
  position: relative;
  z-index: 1;
}
.download-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
